import { render, staticRenderFns } from "./sendFailedPopup.vue?vue&type=template&id=310d03b9&scoped=true&"
import script from "./sendFailedPopup.vue?vue&type=script&lang=js&"
export * from "./sendFailedPopup.vue?vue&type=script&lang=js&"
import style0 from "./sendFailedPopup.vue?vue&type=style&index=0&id=310d03b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310d03b9",
  null
  
)

export default component.exports